import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

export const COMPETITION_PROTOCOL_REQUEST = 'FETCH_COMPETITION_PROTOCOL_REQUEST';
export const COMPETITION_PROTOCOL_FAILURE = 'FETCH_COMPETITION_PROTOCOL_FAILURE';
export const COMPETITION_PROTOCOL_SUCCESS = 'FETCH_COMPETITION_PROTOCOL_SUCCESS';

/*
 * `showHeadClub`: «Показувати головний клуб» on the Reports tab (14 Oct 2026)
 * — the athletes' «Клуб» column names the head club, and the club rating
 * sums branches into it.
 */
export const fetchCompetitionTeamRanksReport = (competition, showHeadClub = false) => {
    return function(dispatch) {
        dispatch(fetchRequest());

        return axios(apiRequestOptions(apiPath.REPORTS.COMPETITION_TEAM_RANKS, showHeadClub ? { headClub: 1 } : null, {
            params: {competition},
            isBlob: true,
        }))
            .then(transformHttpResponse)
            .then(response => {
                const content = response.headers['content-type'];
                const contentDisposition = response.headers['content-disposition'] || '';
                const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
                const filename = filenameMatch ? filenameMatch[1] : 'report.pdf';
                download(response.data, filename, content);
                dispatch(fetchSuccess());
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => ({type: COMPETITION_PROTOCOL_REQUEST});

const fetchFailure = error => ({type: COMPETITION_PROTOCOL_FAILURE, error,});

const fetchSuccess = () => ({type: COMPETITION_PROTOCOL_SUCCESS});
